import Avatar from "@/components/avatar/Avatar.vue";
import FilterChallenge from "@/components/filterChallenge/FilterChallenge.vue";
import GameCard from "@/components/gameCard/gameCard.vue";
import Leaderboard from "@/components/leaderboard/Leaderboard.vue";
import LeftHall from "@/components/leftHall/LeftHall.vue";
import LeftPanel from "@/components/leftPanel/LeftPanel.vue";
import ListGame from "@/components/listGame/ListGame.vue";
import ListSettings from "@/components/settingsCreateChallenge/index";
import Settings from "@/components/settingsCreateChallenge/settings/Settings.vue";
import LoginWithSocialNetwork from "@/components/loginWithSocialNetwork/LoginWithSocialNetwork.vue";
import ProfileHeader from "@/components/profileHeader/ProfileHeader.vue";
import RegisterForm from "@/components/registerForm/registerForm.vue";
import RightHall from "@/components/rightHall/RightHall.vue";
import RightPanel from "@/components/rightPanel/RightPanel.vue";
import SelectLanguage from "@/components/selectLanguage/SelectLanguage.vue";
import SelectRole from "@/components/selectRole/SelectRole.vue";
import PlayerRankings from "@/components/playerRankings/PlayerRankings.vue";
import AllUIElement from "@/components/ui-elements/index";
import RoomCard from "@/components/roomCard/RoomCard.vue";
import Loading from "@/components/loading/Loading.vue";
import SettingsChallenge from "@/components/settingsChallenge/SettingsChallenge.vue";
import PreviewQuestion from "@/components/previewQuestion/PreviewQuestion.vue";
import EnterPin from "@/components/enterPin/EnterPin.vue";
import Logo from "@/components/logo/Logo.vue";
import TopChallenge from "@/components/topChallenge/TopChallenge.vue";
import UploadImage from "@/components/uploadImage/UploadImage.vue";
import CountDown from "@/components/countDown/CountDown.vue";

export default [
  ...AllUIElement,
  {
    name: "Avatar",
    component: Avatar
  },
  {
    name: "FilterChallenge",
    component: FilterChallenge
  },
  {
    name: "GameCard",
    component: GameCard
  },
  {
    name: "Leaderboard",
    component: Leaderboard
  },
  {
    name: "LeftHall",
    component: LeftHall
  },
  {
    name: "LeftPanel",
    component: LeftPanel
  },
  {
    name: "ListGame",
    component: ListGame
  },
  {
    name: "ListSettings",
    component: ListSettings
  },
  {
    name: "Settings",
    component: Settings
  },
  {
    name: "LoginWithSocialNetwork",
    component: LoginWithSocialNetwork
  },
  {
    name: "ProfileHeader",
    component: ProfileHeader
  },
  {
    name: "RegisterForm",
    component: RegisterForm
  },
  {
    name: "RightHall",
    component: RightHall
  },
  {
    name: "RightPanel",
    component: RightPanel
  },
  {
    name: "SelectLanguage",
    component: SelectLanguage
  },
  {
    name: "SelectRole",
    component: SelectRole
  },
  {
    name: "PlayerRankings",
    component: PlayerRankings
  },
  {
    name: "RoomCard",
    component: RoomCard
  },
  {
    name: "Loading",
    component: Loading
  },
  {
    name: "SettingsChallenge",
    component: SettingsChallenge
  },
  {
    name: "PreviewQuestion",
    component: PreviewQuestion
  },
  {
    name: "EnterPin",
    component: EnterPin
  },
  {
    name: "Logo",
    component: Logo
  },
  {
    name: "TopChallenge",
    component: TopChallenge
  },
  {
    name: "UploadImage",
    component: UploadImage
  },
  {
    name: "CountDown",
    component: CountDown
  }
];
